import { render, staticRenderFns } from "./edit.custom-components.page.vue?vue&type=template&id=237e34b0&"
import script from "./edit.custom-components.page.vue?vue&type=script&lang=js&"
export * from "./edit.custom-components.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports